import { Stack, Typography } from '@mui/material';
import { FieldValues } from 'react-hook-form';
import { SetOptional } from 'type-fest';

import {
  FormAwareRadioGroup,
  FormAwareRadioGroupProps,
} from '@/components/form/formAwareInputs/FormAwareRadioGroup';
import {
  FormAwareTextEditor,
  FormAwareTextEditorProps,
} from '@/components/form/formAwareInputs/FormAwareTextEditor';
import { Card } from '@/components/layout/Card/Card';

import { GraphVizNodeComponentTypeOptions } from '../graphVizNodeConfig';

const Notes = <FormShape extends FieldValues>({
  label = 'Tile notes',
  ...props
}: SetOptional<FormAwareTextEditorProps<FormShape>, 'label'>) => {
  return (
    <FormAwareTextEditor
      label={label}
      rows={6}
      omitBlockTypes={['h1', 'h2', 'h3', 'quote']}
      allowTableInsert={false}
      preserveNewLines
      {...props}
    />
  );
};

const ComponentType = <FormShape extends FieldValues>({
  label = 'Display as',
  ...props
}: SetOptional<
  FormAwareRadioGroupProps<FormShape>,
  'label' | 'options' | 'row'
>) => {
  return (
    <Card variant="filled" sx={{ p: '16px' }}>
      <Stack spacing={2}>
        <Stack spacing={0.5}>
          <Typography variant="title-s">{label}</Typography>
        </Stack>
        <FormAwareRadioGroup
          hideLabel
          options={GraphVizNodeComponentTypeOptions}
          required
          row={false}
          {...props}
        />
      </Stack>
    </Card>
  );
};

export const GraphVizNodeConfigFormField = {
  Notes,
  ComponentType,
};
